/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import RowDataTable from "./RowDataTable.jsx";
import {Containers} from "../Objects/Containers.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import {UI} from "../UIGenerator.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import ElementStatus from "./ElementStatus.jsx";

class ContainerManagement extends Component {
    constructor() {
        super();
        this.state = {
            allContainers: []
        }
    }


    async fetchData() {
        let allContainers = await Containers().listAll()
        this.setState({allContainers: allContainers?.recordset || allContainers || []})
    }

    componentDidMount() {
        this.fetchData()
    }


    async editContainer(container) {
        let elementPath = "/c/" + container.indexKey


        UI.page().navigate({
            pathname: elementPath
        })
        // UI.drawer(Util.unique.newInternalId(), (state, setState, close) => {
        //     return (<div className={"p-2"}>
        //         <OutputList>
        //             <OutputListItem titel={"ContainerName"}>
        //                 <span>{domain.containerName}</span>
        //             </OutputListItem>
        //             <OutputListItem titel={"ImageIndexKey"}>
        //                 <span>{domain.imageIndexKey}</span>
        //             </OutputListItem>
        //             <OutputListItem titel={""}>
        //                 <ButtonComponent
        //                     text={"Remove Container"}
        //                     onClick={async () => {
        //                         await Containers(domain.indexKey).remove()
        //                         await this.fetchData()
        //                         close()
        //                     }}></ButtonComponent>
        //
        //
        //             </OutputListItem>
        //
        //         </OutputList>
        //     </div>)
        //
        // }, (state, close) => {
        //     close()
        // }, {
        //     title: "Edit Domain", button: [{
        //         type: "abort",
        //         text: "Abbrechen",
        //         onClick: (inputState, setState, close) => {
        //             close()
        //         }
        //     }]
        // }).open()


    }

    render() {
        let {allContainers} = this.state

        return (
            <div>
                <RowDataTable
                    selectedIndex={this.state.selectedIndex}
                    iconElement={(row) => {
                        return (<div
                            className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                            <DisplayIcon iconName={"Container"} size={"1.1rem"}/>
                        </div>)
                    }}
                    buttons={(row) => {
                        return <>
                            <ElementStatus name={"Container"} elementId={row.indexKey}/>

                            {row?.URL !== undefined && (<>
                                <IconButtonComponent text={`Open`}
                                                     iconName={"IoEyeOutline"}
                                                     onClick={() => {
                                                         let url = "/a/" + row.URL.replace(/^\//g, '')
                                                         // open the page
                                                         UI.page().navigate({
                                                             pathname: url,
                                                         })
                                                     }}/>
                            </>)}

                            <IconButtonComponent text={`Edit `}
                                                 iconName={"IoPencilOutline"}
                                                 onClick={() => {
                                                     UI.page().navigate({
                                                         pathname: "/layout/edit",
                                                         search: '?indexKey=' + row.indexKey,
                                                         state: {data: row}
                                                     })

                                                 }}/>
                        </>

                    }}
                    data={allContainers.map(item => ({
                        ...item,
                        Name: <>{item.containerName} </>

                    }))}
                    emptyState={() => {
                        return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                 text={<div className={"w-96 space-y-3"}>
                                                     <TextElement
                                                         textType={"header-lg"}> Keine test mit
                                                         dem Namen: "<span
                                                             className={"italic"}>{this.state.searchinput}</span>"
                                                         gefunden</TextElement>

                                                     <ButtonComponent iconName={"IoAdd"}
                                                                      onClick={() => {
                                                                          //AppActions.layout.newLayout()
                                                                      }}
                                                                      text={`Neue  `}/>
                                                 </div>}/></>)

                    }}
                    progressPending={!this.state.isLoadedComplete}
                    onRowClicked={(data) => {
                        this.editContainer(data)

                    }}
                    onMiddleMouseClick={(data) => {
                    }}
                />

            </div>
        );
    }
}

export default ContainerManagement;